<template>
  <div>
    <div class="px-6">
      <div class="text-center Kanit my-5" style="font-weight: 500">
        สร้างบัญชีสมาชิก
      </div>
      <ValidationObserver ref="observer">
        <ValidationProvider
          name="เบอร์โทรศัพท์"
          :rules="'required|thai_phonenumber'"
          ref="emailorphone"
          v-slot="{ errors }"
        >
          <div>เบอร์โทรศัพท์<span class="red--text">*</span></div>
          <div class="red--text" style="font-size: 13px;">
            ระบบจะส่ง SMS ยืนยันตัวตนไปที่เบอร์โทรศัพท์
          </div>
          <custom-input
            :maxlength="10"
            outlined
            dense
            :error-messages="errors"
            v-model="input.username"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          vid="passwordconfirm"
          name="รหัสผ่าน"
          :rules="'required|passwordLength'"
          v-slot="{ errors }"
        >
          <div>กำหนดรหัสผ่าน<span class="red--text">*</span></div>
          <custom-input
            outlined
            :type="'password'"
            dense
            :error-messages="errors"
            v-model="input.password"
          ></custom-input>
        </ValidationProvider>
        <ValidationProvider
          name="ยืนยันรหัสผ่าน"
          :rules="'required|confirmed:passwordconfirm'"
          v-slot="{ errors }"
        >
          <div>ยืนยันรหัสผ่าน<span class="red--text">*</span></div>
          <custom-input
            outlined
            dense
            :type="'password'"
            :error-messages="errors"
            v-model="confirm_password"
          ></custom-input>
        </ValidationProvider>
        <div class="text-center">
          <v-btn :loading="saveloading" @click="next" color="primary">
            ถัดไป
          </v-btn>
        </div>
      </ValidationObserver>
      <div class="mt-5 text-center">
        หากเป็นสมาชิกอยู่แล้ว&nbsp;<span class="red--text" @click="login"
          ><u>เข้าสู่ระบบ</u></span
        >&nbsp;ที่นี่
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "../../components/CustomInput.vue";
import axios from "axios";
export default {
  components: { CustomInput },
  data() {
    return {
      confirm_password: "",
      saveloading: false,
    };
  },
  computed: {
    input() {
      return this.$store.state.input;
    },
    pageId() {
      return this.query.pageid;
    },
  },
  created() {
    this.$store.state.headertext = "REGISTER";
  },
  methods: {
    async next() {
      if (await this.$refs.observer.validate()) {
        this.saveloading = true;
        axios
          .get(this.serverUrl + "yasale/account/duplicate", {
            headers: { AUTHORIZATION: "Bearer xxxx xxxx" },
            params: {
              username: this.input.username,
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              let body = {
                pageId: this.pageId,
                userId: this.userid,
                phone: this.input.username,
              };
              let otpResult = await axios.post(
                this.serverUrl + "yasale/otp/send",
                body,
                {
                  headers: {
                    AUTHORIZATION: "Bearer xxx xxx",
                  },
                }
              );
              if (otpResult.data && otpResult.data.responsecode == 200) {
                this.$store.state.ref = otpResult.data.data;
              } else {
                this.$swal.fire({
                  type: "error",
                  text: "มีบางอย่างผิดพลาด",
                });
              }
              this.saveloading = false;
              this.$emit("nextstep");
            } else {
              this.saveloading = false;
              await this.$swal.fire({
                text: response.data.reason,
              });
              if (response.data.responsecode == 400) {
                this.$liff.closeWindow();
              }
            }
          });
      }
    },
    login() {
      this.$store.state.query.view = "Login";
    },
  },
};
</script>

<style lang="scss" scoped></style>
